import {OverTopReelEffectsView} from 'src/overtopreel/OverTopReelEffectsView';
import {Module} from '@fantasmagames/slot/src/common/Module';
import {GameViews} from 'src/GameViews';
import {GameAvalancheReelsEvents} from 'src/avalanche/GameAvalancheReelsEvents';
import {Symbols} from 'src/reels/Symbols';
import {StartScreenEvents} from '@fantasmagames/slot/src/modules/startscreen/StartScreenEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';

export class OverTopReelEffectsModule extends Module<OverTopReelEffectsView> {
	protected enterFirstState(): void {
	}

	protected setupStates(): void {
	}

	public restore(): void {
		super.restore();

		if (this.logic.isFreeSpinsStarted) {
			this.view.isInFreeSpins = true;
		}
	}

	protected setupViews(): void {
		this.setView(GameViews.UNDER_TOP_REELS_VIEW);
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(GameAvalancheReelsEvents.SYMBOL_PASSED_THROUGHT_LINE, this.onSymbolPassesThroughLine);
		this.on(StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
		this.on(StartScreenEvents.EXIT_FINISHED, this.onStartScreenIntroFinished);

		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
	}

	protected onFreeSpinsIntroStarted(): void {
		this.view.isInFreeSpins = true;
		this.view.hide();
	}

	protected onFreeSpinsOutroStarted(): void {
		this.view.isInFreeSpins = false;
		this.view.hide();
	}

	protected onFreeSpinsIntroFinished(): void {
		this.view.show();
	}

	protected onFreeSpinsOutroFinished(): void {
		this.view.show();
	}

	protected onStartScreenIntroStarted(): void {
		this.view.hide();
	}

	protected onStartScreenIntroFinished(): void {
		this.view.show();
	}

	protected onSymbolPassesThroughLine(eventID: string, symbolID: number, newRowPos: number): void {
		if (symbolID === Symbols.TOP_WR || symbolID === Symbols.WR ||
			symbolID === Symbols.TOP_RS || symbolID === Symbols.RS ||
			symbolID === Symbols.TOP_BN || symbolID === Symbols.BN) {
			this.view.playSpecialDropIn(newRowPos - 2);
		} else {
			this.view.playOrdinaryDropOn(newRowPos - 2);
		}
	}
}



// WEBPACK FOOTER //
// ./src/overtopreel/OverTopReelEffectsModule.ts